import useSWRMutation from 'swr/mutation'
import { adaptFetcherToSWRMutationFn } from 'shared/api/utils/adapt-fetcher-to-swr-mutation'
import { useApiWrapperWithErrorValidation } from 'shared/hooks/use-api-wrapper-with-error-validation'
import { RequestMethodsEnum } from 'shared/hooks/use-api-wrapper-with-error-validation/types'
import { MEMBERSHIP_API } from 'modules/school/api/membership-api'

export const useSubmitAssignment = (lectureId: number) => {
  const { fetcher: assignmentFetcher } = useApiWrapperWithErrorValidation<RequestMethodsEnum.post>({
    method: RequestMethodsEnum.post,
  })

  return useSWRMutation(
    `${MEMBERSHIP_API}/lecture/${lectureId}/assignment`,
    adaptFetcherToSWRMutationFn(assignmentFetcher),
  )
}
